<template>
	<frontend-layout>
		<Head>
			<title>{{ status }} - {{ $t("siteTitle") }}</title>
		</Head>
		<section>
			<div class="ts-image is-centered">
				<img class="error-image" src="/img/ufo.webp" />
			</div>
			<div class="ts-text ts-center is-heavy error-code">
				{{ status }}
			</div>
			<div class="ts-text is-huge is-bold ts-center">
				{{ $t("error.oops") }}
			</div>
			<div class="ts-text is-large ts-center">
				{{
					$te("error." + status)
						? $t("error." + status)
						: $t("error.unknown")
				}}
			</div>
			<div class="ts-text is-large ts-center">
				{{
					$te("error." + status + "-cont")
						? $t("error." + status + "-cont")
						: ""
				}}
			</div>
		</section>
	</frontend-layout>
</template>

<script>
import FrontendLayout from "@/Frontend/Shared/Layout";

export default {
	props: {
		status: Number,
	},
	components: {},
	data() {
		return {
			csrf: document
				.querySelector('meta[name="csrf-token"]')
				.getAttribute("content"),
		};
	},
	methods: {},
	created: function () {},
	mounted: function () {},
	components: {
		FrontendLayout,
	},
};
</script>
<style scoped>
.error-image {
	width: 25%;
	margin-top: 1.2rem;
}

.error-code {
	color: #7e55d4;
	font-size: 3.5rem;
}
</style>
